import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Paper,
  } from "@mui/material";
  import React, { useState } from "react";
  import { MdAdd, MdDelete } from "react-icons/md";
  import { Link } from "react-router-dom";
  import {
    useGetAllLedgerQuery,
    useRemoveledgerMutation,
  } from "../../features/api/ledgerApi";
  import { toast } from "react-toastify";
  
  const LedgerList = () => {
    const { data, isLoading } = useGetAllLedgerQuery(null, {
      refetchOnMountOrArgChange: true,
    });
    const getLedger = data?.ledger_list;
  
    const [removeLedgerList] = useRemoveledgerMutation();
  
    const handleDelete = async (id) => {
      const confirm = window.confirm("Are Your Sure?");
      if (confirm) {
        try {
          const result = await removeLedgerList(id);
  
          if (result) {
            toast.success("Delete Success..!!!");
          }
        } catch (error) {
          console.log(error);
        }
      }
    };
  
    const [searchTerm, setSearchTerm] = useState("");
    const [searchResults, setSearchResults] = useState([]);
  
    const handleSearchChange = (event) => {
      const searchTerm = event.target.value;
      setSearchTerm(searchTerm);
  
      const filteredResults = getLedger?.filter((item) =>
        item?.ledgerName.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setSearchResults(filteredResults);
    };
  
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
  
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
    return (
      <div className="p-8">
        <div className="flex justify-between items-center px-12 my-6">
          <h1 className="text-xl font-bold">Ledger List</h1>
          <Link to={"/dashboard/create-ledger"}>
            <MdAdd className="text-2xl text-white bg-blue-500 font-bold cursor-pointer" />
          </Link>
        </div>
        <input
          type="text"
          placeholder="Search items"
          className="border ml-12 focus:outline-none h-8 rounded p-1"
          value={searchTerm}
          onChange={handleSearchChange}
        />
        <div className="h-[75vh] overflow-auto max-w-sm lg:max-w-[960px] m-auto">
          {isLoading ? (
            <div className="w-fll h-screen flex flex-col items-center justify-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
            </div>
          ) : getLedger?.length === 0 ? (
            <p className=" text-xl text-red-500">There are no ledger</p>
          ) : (
            <TableContainer component={Paper}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <span className="font-bold">Sl No.</span>
                    </TableCell>
                    <TableCell>
                      <span className="font-bold">Ledger Name</span>
                    </TableCell>
                    <TableCell>
                      <span className="font-bold">Ledger Tag</span>
                    </TableCell>
                    <TableCell>
                      <span className="font-bold">Action</span>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {searchTerm
                    ? searchResults
                        ?.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        ?.map((row, i) => (
                          <TableRow key={row.id}>
                            <TableCell>{i + 1}</TableCell>
                            <TableCell>{row.ledgerName}</TableCell>
                            <TableCell>{row.ledger_tag}</TableCell>
                            <TableCell className="">
                              <div className="flex items-center gap-x-4">
                                <span onClick={() => handleDelete(row?.id)}>
                                  <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                                </span>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))
                    : getLedger
                        ?.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        ?.map((row, i) => (
                          <TableRow key={row.id}>
                            <TableCell>{i + 1}</TableCell>
                            <TableCell>{row.ledgerName}</TableCell>
                            <TableCell>{row.ledger_tag}</TableCell>
                            <TableCell className="">
                              <div className="flex items-center gap-x-4">
                                <span onClick={() => handleDelete(row?.id)}>
                                  <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                                </span>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[50, 100, 200]}
                component="div"
                count={getLedger?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableContainer>
          )}
        </div>
      </div>
    );
  };
  
  export default LedgerList;